import DeviceTypePicker from './DeviceTypePicker'

export default DeviceTypePicker
